import { AstNodeCategory, AstNodeType } from './node';
export class DeleteStatement {
    constructor(_token, _name) {
        this._token = _token;
        this._name = _name;
        this.nodeType = AstNodeType.DeleteStatement;
        this.nodeCategory = AstNodeCategory.Statement;
    }
    get Token() {
        return this._token;
    }
    set Token(val) {
        this._token = val;
    }
    get Name() {
        return this._name;
    }
    set Name(val) {
        this._name = val;
    }
    tokenLiteral() {
        var _a;
        return ((_a = this._token) === null || _a === void 0 ? void 0 : _a.literal) || '';
    }
    toString() {
        var _a;
        return `${this.tokenLiteral()} ${(_a = this.Name) === null || _a === void 0 ? void 0 : _a.toString()};`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVsZXRlU3RhdGVtZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hc3QvRGVsZXRlU3RhdGVtZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUFhLE1BQU0sUUFBUSxDQUFDO0FBRWpFLE1BQU0sT0FBTyxlQUFlO0lBQ3hCLFlBQW9CLE1BQWMsRUFBVSxLQUFrQjtRQUExQyxXQUFNLEdBQU4sTUFBTSxDQUFRO1FBQVUsVUFBSyxHQUFMLEtBQUssQ0FBYTtRQUM5RCxhQUFRLEdBQWdCLFdBQVcsQ0FBQyxlQUFlLENBQUM7UUFDcEQsaUJBQVksR0FBb0IsZUFBZSxDQUFDLFNBQVMsQ0FBQztJQUZPLENBQUM7SUFJbEUsSUFBSSxLQUFLO1FBQ0wsT0FBTyxJQUFJLENBQUMsTUFBZSxDQUFDO0lBQ2hDLENBQUM7SUFFRCxJQUFJLEtBQUssQ0FBQyxHQUFVO1FBQ2hCLElBQUksQ0FBQyxNQUFNLEdBQUcsR0FBRyxDQUFDO0lBQ3RCLENBQUM7SUFFRCxJQUFJLElBQUk7UUFDSixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7SUFDdEIsQ0FBQztJQUVELElBQUksSUFBSSxDQUFDLEdBQUc7UUFDUixJQUFJLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQztJQUNyQixDQUFDO0lBRUQsWUFBWTs7UUFDUixPQUFPLENBQUEsTUFBQSxJQUFJLENBQUMsTUFBTSwwQ0FBRSxPQUFPLEtBQUksRUFBRSxDQUFDO0lBQ3RDLENBQUM7SUFFRCxRQUFROztRQUNKLE9BQU8sR0FBRyxJQUFJLENBQUMsWUFBWSxFQUFFLElBQUksTUFBQSxJQUFJLENBQUMsSUFBSSwwQ0FBRSxRQUFRLEVBQUUsR0FBRyxDQUFDO0lBQzlELENBQUM7Q0FDSiJ9